var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('review-tags-settings-list',{attrs:{"tags":_vm.review.tags,"can-edit":_vm.canEdit,"disabled":_vm.disabled,"small":_vm.small},on:{"createTag":_vm.createTag,"updateTag":_vm.updateTag,"deleteTag":_vm.deleteTag}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }